import { Box, Typography } from '@astro-ui/components'
import theme from '@astro-ui/theme'
import Table from './Table'

const ActivityStatus = () => (
  <Box
    id="aktivitas-status-so"
    borderRadius="8px"
    border="1px solid"
    borderColor={theme.colors.border}
    backgroundColor={theme.colors.white}
    overflow="auto"
  >
    <Box display="flex" padding="24px">
      <Typography variant="display-tiny" whiteSpace="nowrap">
        Aktivitas Status SO
      </Typography>
    </Box>

    <Table />
  </Box>
)

export default ActivityStatus
